import { getData } from '../api/server'

const Url = {
    menu: '/cms/page/data/menu', //菜单
    media: '/cms/page/data/multimedia', //多媒体
    slide: '/cms/page/data/slide', //轮播图
    article: '/cms/page/data/article',//文章详情
    catalogue: '/cms/page/data/catalogue', //目录接口
    search: '/cms/page/data/search/articles', //搜索接口
    preAndNext: '/cms/page/data/article/preAndNext', //上下篇接口
    childCat: '/cms/page/data/catalogues', //目录
    menuItems: '/cms/page/data/menuItems', //侧边栏接口
    languages: '/cms/page/data/languages', //语言接口列表
    multimedia: '/cms/page/data/multimedia', //多媒体接口
    breadCrumb: '/cms/page/data/breadcrumb', // 面包屑

    addMessage:'/cms/page/data/connection/add',  //官网留言
    statistic: '/cms/page/pv/statistic',
    siteInfo: '/cms/page/data/site/info', // 获取网站信息
}

export default {
    GET_DATA: ({ commit, dispatch, state }, {key, value, payload}) => {
        return getData(Url[`${key}`], payload)
            .then(({data}) => {
                const newDatta = data;
                if (data.code === 10000) {
                    const param = {
                        type: value,
                        data: data.data,
                        dataTotal: newDatta,
                    }
                    commit('SAVE', param)
                } else {
                    const param = {
                        type: value,
                        data: newDatta,
                    }
                    commit('FailSave', param);
                }

                // if(value == 'addMessage' ){
                //     const param = {
                //     type: value,
                //     data: data,
                // }
                //     commit('SAVE', param)
                // }else{
                //     if(data.code === 10000){
                //         const param = {
                //             type: value,
                //             data: data.data,
                //         }
                //         commit('SAVE', param)
                //     }
                // }

            })
    },
}